import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { saveCommonClsSvc } from "./CommonClsSvc";

const EligibleTchPopup = (props) => {
    const { commonClsId, subId, eligibleTchId, lstSectionId, closePopup, setLoader, lstTch, getCommonClsList, closeSlider, daysOff, periodsOff } = props;
    const [tchId, setTchId] = useState(0)
   
    useEffect(()=>{
       setTchId(eligibleTchId) 
    },[eligibleTchId])

    function saveCommonCls() {
        if (subId == '' || subId == 0) {
            toast.warn("Please select the subject")
            return;
        }
        if (lstSectionId.length <= 1) {
            toast.warn("Please select atleast 2 classes");
            return;
        }

        if (tchId == 0) {
            toast.warn("Please select the teacher");
            return;
        }
        setLoader("block");
        const objCommonCls = {
            subId: subId,
            lstSection: lstSectionId,
            tchId: tchId, 
            daysOff: daysOff,
            periodsOff: periodsOff
        }
        var formData = new FormData();
        formData.append("objCommonCls", JSON.stringify(objCommonCls))
        setLoader("block")
        saveCommonClsSvc(formData, cbSaveCommonClsResponse)
    }

    function cbSaveCommonClsResponse(data) {
        setLoader("none");
        if (data.status === 'Success') {
            toast.success(data.SvcMsg)
            closePopup();
            closeSlider();
            getCommonClsList();
        }
        else {
            if (data.message === "You are not logged in") {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else if (data.message === "Your Session is expired, login again") {
                toast.error(data.message);
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(data.message);
            }
        }
    }
    return (
        <div style={{ display: "flex", justifyContent: "center", position: "absolute", padding: 0, top: "15%", left: "10%", backgroundColor: "#F8F8F8", width: 500, height: 225, zIndex: 1001 }}>
            <div className="form-horizontal formWrapper" style={{ width: "100%", height: "100%", margin: 0 }}>
                <div className="form-group" style={{marginTop:'15%',height:'70%'}}>
                    <label className="control-label col-sm-5">Teacher</label>
                    <div className="col-sm-3 padding-remove">
                        <select
                            className="form-control"
                            value={''+tchId}
                            onChange={(e) => setTchId(e.target.value)}
                        >
                            <option value={0}>Teacher</option>
                            {lstTch && lstTch.length ?
                                  lstTch.map((tch) => (
                                    <option key={tch.tchId} value={tch.tchId} >{tch.tch}</option>
                                )) : null
                            }
                        </select>
                    </div>
                </div>
                <div className="form-group" style={{ marginTop: 10 }}>
                    <div className="col-sm-12 text-center userButtonWrap" >
                        <button type="button" title="Save" onClick={() => saveCommonCls()} className="btn btn-info">Save</button>
                        <button type="button" title="Cancel" onClick={() => closePopup()} className="btn btn-info">Close</button>
                        {/* {commonClsId == 0 &&
                            <button type="button" title="Delete" onClick={() => deletePeriod(schedulePeriodId)} className="btn btn-danger deleteButton">Delete</button>
                        } */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EligibleTchPopup;